import {
  EXCURSION_REPORT_FETCH_STARTED,
  EXCURSION_REPORT_FETCH_SUCCEEDED,
  EXCURSION_REPORT_FETCH_FAILED,
  EXCURSION_REPORT_CLEAR
} from '#action/types';

const initialState = {
  loading: false,
  error: null,
  data: null
};

export default function excursionReport(state = initialState, action) {
  switch (action.type) {
    case EXCURSION_REPORT_FETCH_STARTED:
      return {
        ...state,
        loading: true,
        error: null
      };

    case EXCURSION_REPORT_FETCH_SUCCEEDED:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };

    case EXCURSION_REPORT_FETCH_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case EXCURSION_REPORT_CLEAR:
      return initialState;

    default:
      return state;
  }
}
